import { z } from 'zod';

import {
  areCreativeDimensionsValid,
  ExtendedFile,
} from '@features/campaigns/builder/utils/areCreativeDimensionsValid.ts';
import { isCreativeFormatValid } from '@features/campaigns/builder/utils/isCreativeFormatValid.ts';
import { isCreativeSizeValid } from '@features/campaigns/builder/utils/isCreativeSizeValid.ts';

export async function validateCreativeImageFile(file: ExtendedFile[], allowedFormats: string[]) {
  const isSizeValid = isCreativeSizeValid(file);
  const isFileFormatValid = isCreativeFormatValid(file, allowedFormats);
  const areDimensionsValid = await areCreativeDimensionsValid(file);
  const isFileValid = isSizeValid && isFileFormatValid && areDimensionsValid;

  return {
    isSizeValid,
    isFileFormatValid,
    areDimensionsValid,
    isFileValid,
  };
}

export async function creativeFileValidationCheck(
  file: ExtendedFile[] | string | null,
  ctx: z.RefinementCtx,
  allowedFormats: string[],
) {
  if (file === null || typeof file === 'string') {
    return true;
  }

  const { isFileFormatValid, isSizeValid, areDimensionsValid } = await validateCreativeImageFile(file, allowedFormats);

  if (!isFileFormatValid) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.creativeFileWrongFormat',
    });
  }

  if (!isSizeValid && !areDimensionsValid) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.comboCreativeFileWrongDimensionsWrongSize',
    });
  }

  if (!isSizeValid) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.creativeFileWrongSize',
    });
  }

  if (!areDimensionsValid) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.creativeFileWrongDimensions',
    });
  }
}
